import moment from 'moment';
Object.defineProperty(Date.prototype, "toLongDate", {
    value: function toLongDate() {
        if(!this) return "";
        let value = this as Date;
        let stringValue = moment(value).format('LL');
        
        return stringValue;
    },
    writable: true,
    configurable: true
});


Object.defineProperty(Date.prototype, "toLongTime", {
    value: function toLongTime() {
        if(!this) return "";
        let value = this as Date;
        let stringValue = moment(value).format('LT');

        return stringValue;
    },
    writable: true,
    configurable: true
});